/* eslint-disable no-debugger */
/* eslint-disable sonarjs/cognitive-complexity */
import { all, put, takeEvery, call, select, takeLatest } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';
import { getExternalId, getTinId, getPostalCode, getRegisterPharmacyInputData, getLanguage } from '@store';
import {
	FileUploadType,
	BuildCustomMessageGenericErrorModal,
	modalOpen,
	BuildOkSuccessModal,
} from '@shared/components';
import {
	ServicesTypes as ST,
	ApiClientManager,
	ApiClientNames,
	ApiClientTypes,
	EnrollmentTypes,
} from '@api/ff-shared-services-api';
import RegisterPharmacyActionTypes, {
	RegisterInputData,
	RegisterFileUploadType,
	SubscriptionTypes,
	StepRegisterInputData,
	ResumeInputData,
	PermanentCertificateTypes,
} from './types';
import {
	LoggerHelper,
	clearError,
	showLoading,
	hideLoading,
	saveError,
	ActionServiceEmpty,
	ActionServicePayload,
	i18n,
} from 'ff-shared-components-core';
import {
	fetchUploadFileExecutionSuccess,
	fetchConfigurationsSuccess,
	fetchAddRegisterDataSuccess,
	fetchUpdateRegisterDataSuccess,
	saveTransferInputData,
} from './actions';
import { fetchProcessTokenSuccess } from './../auth/actions';
import { handleApiError } from '@helpers';
import {
	buildPostalCode,
	getRequestValue,
	buildPhoneNumber,
	buildUsersData,
	getRequestValueDef,
	getRequestStepNameByIndex,
	buildUsersStateFomData,
} from './helpers';
import { EmptyAction } from 'typesafe-actions';

export function* handlePublicRegisterInitFetch(
	action: ActionServicePayload<EnrollmentTypes.Request>
): SagaIterator<void> {
	yield put(clearError());
	yield put(showLoading());

	try {
		/* Params */
		LoggerHelper.log('PUBLIC REGISTER > SAGA > handleAddRegisterDataFetch > ');

		/* API call */
		const apiContext = ApiClientManager.call<ApiClientTypes.EnrollmentApi>(ApiClientNames.EnrollmentApi);
		const res: EnrollmentTypes.EnrollmentStartOutput = yield call([apiContext, apiContext.startEnrollmentUsingGET]);

		LoggerHelper.log('PUBLIC REGISTER > SAGA > handleAddRegisterDataFetch > res ', res);

		if (res && res.accessToken) {
			yield put(fetchProcessTokenSuccess(res.accessToken));

			yield put(fetchConfigurationsSuccess(res.configuration));

			yield put(fetchAddRegisterDataSuccess(res.externalId));

			if (action.meta && action.meta.successHandler) {
				action.meta.successHandler(res);
			}
		}
	} catch (err) {
		action.meta = { ...action.meta, showModalError: true };

		action.meta && action.meta.successHandler && action.meta.successHandler({ hasError: true });

		yield* handleApiError('pt', err, saveError, action.meta);
	} finally {
		yield put(hideLoading());
	}
}

export function* handlePublicRegisterResumeFetch(action: ActionServicePayload<ResumeInputData>): SagaIterator<void> {
	yield put(clearError());
	yield put(showLoading());

	try {
		/* Params */
		// debugger;

		const externalId = action.payload.externalId ?? undefined;

		// const externalId = '1328c008-0256-4124-b925-83e191d79d08';

		/* API call */
		const apiContext = ApiClientManager.call<ApiClientTypes.EnrollmentApi>(ApiClientNames.EnrollmentApi);
		const res: EnrollmentTypes.ResumeDraftRequestOutput = yield call(
			[apiContext, apiContext.resumeRequestUsingGET],
			externalId
		);

		debugger;

		const receivedRegisterRes = res.request;

		const [postalCodePrefix, postalCodeSuffix] = receivedRegisterRes.zipCode
			? receivedRegisterRes.zipCode.split('-', 2)
			: ['', ''];

		debugger;
		const inputRegisterState: RegisterInputData = {
			/** The Tax identification number. */
			nipc: receivedRegisterRes.tin ? receivedRegisterRes.tin : '',
			/** The name of the entity. */
			entityName: receivedRegisterRes.entityName ? receivedRegisterRes.entityName : '',
			/** The primary address. */
			address: receivedRegisterRes.address1 ? receivedRegisterRes.address1 : '',
			/** The Zip code. */
			postalCodePrefix: postalCodePrefix, // receivedRegisterRes.zipCode ? receivedRegisterRes.zipCode : '',
			/** The Zip code. */
			postalCodeSuffix: postalCodeSuffix, //receivedRegisterRes.zipCode ? receivedRegisterRes.zipCode : '',
			/** The province of the entity. */
			locality: receivedRegisterRes.province ? receivedRegisterRes.province : '',
			/** The name of the responsible individual. */
			preferredContactName: receivedRegisterRes.contactName ? receivedRegisterRes.contactName : '',
			/** The email of the responsible individual. */
			preferredContactEmail: receivedRegisterRes.contactEmail ? receivedRegisterRes.contactEmail : '',
			/** The phone number of the responsible individual. */
			preferredContactPhonePrefix: receivedRegisterRes.contactPhoneCountry
				? receivedRegisterRes.contactPhoneCountry
				: '', //receivedRegisterRes.contactPhone ? receivedRegisterRes.contactPhone : '',
			/** The phone number of the responsible individual. */
			preferredContactPhoneNumber: receivedRegisterRes.contactPhone ? receivedRegisterRes.contactPhone : '', //receivedRegisterRes.contactPhone ? receivedRegisterRes.contactPhone : '',
			/** Required signings. */
			// signaturesNumber: receivedRegisterRes.requiredSigns ? receivedRegisterRes.requiredSigns : 1,
			/** If this entity needs more then one signature to validate documents. */
			subscription:
				receivedRegisterRes.requiredSignaturesOption === EnrollmentTypes.RequestRequiredSignaturesOption.MORE
					? SubscriptionTypes.moreThanOneSubscription
					: SubscriptionTypes.oneSubscription,
			/** The permanent certification code. */
			permanentCertificateCode: receivedRegisterRes.permanentCertificateCode
				? receivedRegisterRes.permanentCertificateCode
				: '',
			/** The permanent certification uploaded file id. */
			proofInputFile: receivedRegisterRes.permanentCertificateDocument
				? {
						id: receivedRegisterRes.permanentCertificateDocument,
						fileName: 'comprovativo',
						inputType: EnrollmentTypes.EnrollmentDocumentDocumentType.CERT_PERM_DOC,
						isDownloadable: true,
				  }
				: undefined,
			typePermanentCertificate: receivedRegisterRes.permanentCertificateDocument
				? PermanentCertificateTypes.file
				: PermanentCertificateTypes.code,
			/** The list of users associated with this entity. */
			usersData: receivedRegisterRes.users ? buildUsersStateFomData(receivedRegisterRes.users) : undefined, //receivedRegisterRes.users ? receivedRegisterRes.users : undefined,
			/** The iban of the entity. */
			ibanNumber: receivedRegisterRes.iban ? receivedRegisterRes.iban : '',
			/** The uploaded iban proof file id. */
			ibanInputFile: receivedRegisterRes.ibanDocument
				? {
						id: receivedRegisterRes.ibanDocument,
						fileName: 'comprovativo',
						inputType: EnrollmentTypes.EnrollmentDocumentDocumentType.IBAN,
						isDownloadable: true,
				  }
				: undefined,
			/** The uploaded contract file id. */
			contractInputFile: receivedRegisterRes.contractCode
				? {
						id: receivedRegisterRes.contractCode,
						fileName: 'contrato',
						inputType: EnrollmentTypes.EnrollmentDocumentDocumentType.CONTRACT,
				  }
				: undefined,
			// lastGeneratedContract: receivedRegisterRes.lastGeneratedContract
			// 	? {
			// 			id: receivedRegisterRes.lastGeneratedContract,
			// 			fileName: 'contrato',
			// 			inputType: EnrollmentTypes.EnrollmentDocumentDocumentType.OTHER,
			// 	  }
			// 	: undefined,
			// messageToClient: receivedRegisterRes.commentSent ? receivedRegisterRes.commentSent : '',
		};

		debugger;

		if (res && res.accessToken) {
			debugger;
			yield put(fetchProcessTokenSuccess(res.accessToken));

			yield put(fetchConfigurationsSuccess(res.configuration));

			yield put(fetchAddRegisterDataSuccess(res.request.externalId));

			yield put(saveTransferInputData(inputRegisterState, 4));

			if (action.meta && action.meta.successHandler) {
				action.meta.successHandler(res);
			}
		}
	} catch (err) {
		debugger;
		action.meta = { ...action.meta, showModalError: true };

		action.meta && action.meta.successHandler && action.meta.successHandler({ hasError: true });

		yield* handleApiError('pt', err, saveError, action.meta);
	} finally {
		yield put(hideLoading());
	}
}

export function* handleSaveRegisterOnCancel(action: ActionServicePayload<string>): SagaIterator<void> {
	yield put(clearError());
	yield put(showLoading());

	try {
		/* Params */
		const externalId = yield select(getExternalId);

		/* API call */
		const apiContext = ApiClientManager.call<ApiClientTypes.EnrollmentApi>(ApiClientNames.EnrollmentApi);

		const res: EnrollmentTypes.SaveDraftRequestOutput = yield call(
			[apiContext, apiContext.saveDraftRequestUsingPOST],
			externalId
		);

		if (res && action.meta && action.meta.successHandler) {
			action.meta.successHandler(res);
		}
	} catch (err) {
		action.meta = { ...action.meta, showModalError: true };
		yield* handleApiError('pt', err, saveError, action.meta);
	} finally {
		yield put(hideLoading());
	}
}

export function* handleUpdateRegisterDataFetch(
	action: ActionServicePayload<StepRegisterInputData>
): SagaIterator<void> {
	yield put(clearError());
	yield put(showLoading());

	try {
		/* Params */
		LoggerHelper.log('PUBLIC REGISTER > SAGA > handleUpdateRegisterDataFetch > action.payload', action.payload);

		const payloadData = (action.payload as StepRegisterInputData).registerInputData ?? undefined;
		const stepIndex = (action.payload as StepRegisterInputData).stepIndex;

		const inputRegisterState: RegisterInputData = yield select(getRegisterPharmacyInputData);
		const externalId = yield select(getExternalId);
		const storeTinId = yield select(getTinId);
		const storeZipCode = yield select(getPostalCode);

		const zipCode = buildPostalCode(payloadData?.postalCodePrefix, payloadData?.postalCodeSuffix);
		// const phoneNumber = buildPhoneNumber(
		// 	payloadData.preferredContactPhonePrefix,
		// 	payloadData.preferredContactPhoneNumber
		// );
		// const storePhoneNumber = buildPhoneNumber(
		// 	inputRegisterState.preferredContactPhonePrefix,
		// 	inputRegisterState.preferredContactPhoneNumber
		// );
		const phoneNumberPrefix = payloadData?.preferredContactPhonePrefix;
		const storePhoneNumberPrefix = inputRegisterState.preferredContactPhonePrefix;
		const phoneNumber = payloadData?.preferredContactPhoneNumber;
		const storePhoneNumber = inputRegisterState.preferredContactPhoneNumber;

		const usersData = buildUsersData(payloadData?.usersData);
		const storeUsersData = buildUsersData(inputRegisterState.usersData);

		//debugger;
		const request: EnrollmentTypes.Request = {
			step: getRequestStepNameByIndex(stepIndex),
			/** The external request id. */
			externalId: externalId,
			/** The Tax identification number. */
			tin: getRequestValue(payloadData?.nipc, storeTinId), //payloadData.nipc ? payloadData.nipc : storeTinId,
			/** The name of the entity. */
			entityName: getRequestValue(payloadData?.entityName, inputRegisterState.entityName), //payloadData.entityName ? payloadData.entityName : inputRegisterState.entityName,
			/** The primary address. */
			address1: getRequestValue(payloadData?.address, inputRegisterState.address), //payloadData.address,
			/** The Zip code. */
			zipCode: getRequestValue(zipCode, storeZipCode), //zipCode,
			/** The province of the entity. */
			province: getRequestValue(payloadData?.locality, inputRegisterState.locality), //payloadData.locality ? payloadData.locality : undefined,
			/** The name of the responsible individual. */
			contactName: getRequestValue(payloadData?.preferredContactName, inputRegisterState.preferredContactName), //payloadData.preferredContactName,
			/** The email of the responsible individual. */
			contactEmail: getRequestValue(payloadData?.preferredContactEmail, inputRegisterState.preferredContactEmail), //payloadData.preferredContactEmail,
			/** Country prefix phone */
			contactPhoneCountry: getRequestValue(phoneNumberPrefix, storePhoneNumberPrefix),
			/** The phone number of the responsible individual. */
			contactPhone: getRequestValue(phoneNumber, storePhoneNumber),
			/** If this entity needs more then one signature to validate documents. */
			requiredSignaturesOption:
				getRequestValue(payloadData?.subscription, inputRegisterState.subscription) ===
				SubscriptionTypes.moreThanOneSubscription
					? EnrollmentTypes.RequestRequiredSignaturesOption.MORE
					: EnrollmentTypes.RequestRequiredSignaturesOption.ONE,
			/** Required signings. */
			requiredSigns: EnrollmentTypes.RequestRequiredSignaturesOption.ONE ? 1 : undefined, // getRequestValueDef(payloadData.signaturesNumber, inputRegisterState.signaturesNumber, 1),
			/** The permanent certification code. */
			permanentCertificateCode: getRequestValue(
				payloadData?.permanentCertificateCode,
				inputRegisterState.permanentCertificateCode
			),
			/** The permanent certification uploaded file id. */
			permanentCertificateDocument: getRequestValue(
				payloadData?.proofInputFile?.id,
				inputRegisterState.proofInputFile?.id
			),
			/** The list of users associated with this entity. */
			users: getRequestValue(usersData, storeUsersData),
			/** The iban of the entity. */
			iban: getRequestValue(payloadData?.ibanNumber, inputRegisterState.ibanNumber),
			/** The uploaded iban proof file id. */
			ibanDocument: getRequestValue(payloadData?.ibanInputFile?.id, inputRegisterState.ibanInputFile?.id),
		};

		/* API call */
		const apiContext = ApiClientManager.call<ApiClientTypes.EnrollmentApi>(ApiClientNames.EnrollmentApi);
		const res: EnrollmentTypes.Request = yield call([apiContext, apiContext.updateRequestUsingPATCH], request);

		LoggerHelper.log('PUBLIC REGISTER > SAGA > handleUpdateRegisterDataFetch > res ', res);

		if (res) {
			yield put(fetchUpdateRegisterDataSuccess(res));

			LoggerHelper.log('PUBLIC REGISTER > SAGA > handleUpdateRegisterDataFetch > action.meta ', action.meta);
			if (action.meta && action.meta.successHandler) {
				action.meta.successHandler();
			}
		}
	} catch (err) {
		const error = err as ST.ResponseError;

		LoggerHelper.log('PUBLIC REGISTER > SAGA > handleUpdateRegisterDataFetch > ERROR > ', err);
		if (error.errorType === ST.ErrorType.INTERNAL) {
			// } && error.errorSubType === 'ITSBadRequestException') {
			// If the error is specifically BUSINESS, InvalidCredential catch the error to show it on the screen
			const lng = yield select(getLanguage);
			const successText = i18n.getResource(
				lng.toLowerCase(),
				'translations',
				'screens.register.wrongInputDataMessage'
			);

			yield put(modalOpen(BuildCustomMessageGenericErrorModal(lng, successText)));
			// yield put(modalOpen(BuildOkInfoModal('Por favor, confirme se os seus dados estão correctos.', 'OK')));
		} else {
			action.meta = { ...action.meta, showModalError: true };
		}
		yield* handleApiError('pt', err, saveError, action.meta);
	} finally {
		yield put(hideLoading());
	}
}

export function* handleSendForApprovalFetch(action: ActionServiceEmpty): SagaIterator<void> {
	yield put(clearError());
	yield put(showLoading());

	try {
		/* Params */
		LoggerHelper.log('PUBLIC REGISTER > SAGA > handleSendForApprovalFetch > ');
		// LoggerHelper.log('PUBLIC REGISTER > SAGA > handleUpdateRegisterDataFetch > action.payload', action.payload);

		const inputRegisterState: RegisterInputData = yield select(getRegisterPharmacyInputData);
		const externalId = yield select(getExternalId);
		const storeTinId = yield select(getTinId);
		const storePostalCode = yield select(getPostalCode);

		const usersData = buildUsersData(inputRegisterState.usersData);

		//debugger;
		const request: EnrollmentTypes.Request = {
			step: undefined, // getRequestStepNameByIndex(4),
			/** The external request id. */
			externalId: externalId,
			/** The Tax identification number. */
			tin: storeTinId,
			/** The name of the entity. */
			entityName: inputRegisterState.entityName,
			/** The primary address. */
			address1: inputRegisterState.address,
			/** The Zip code. */
			zipCode: storePostalCode,
			/** The province of the entity. */
			province: inputRegisterState.locality,
			/** The name of the responsible individual. */
			contactName: inputRegisterState.preferredContactName,
			/** The email of the responsible individual. */
			contactEmail: inputRegisterState.preferredContactEmail,
			/** Country prefix phone */
			contactPhoneCountry: inputRegisterState.preferredContactPhonePrefix,
			/** The phone number of the responsible individual. */
			contactPhone: inputRegisterState.preferredContactPhoneNumber,
			/** If this entity needs more then one signature to validate documents. */
			requiredSignaturesOption:
				inputRegisterState.subscription === SubscriptionTypes.moreThanOneSubscription
					? EnrollmentTypes.RequestRequiredSignaturesOption.MORE
					: EnrollmentTypes.RequestRequiredSignaturesOption.ONE,
			/** Required signings. */
			requiredSigns: EnrollmentTypes.RequestRequiredSignaturesOption.ONE ? 1 : undefined,
			/** The permanent certification code. */
			permanentCertificateCode:
				inputRegisterState.typePermanentCertificate === 'code'
					? inputRegisterState.permanentCertificateCode
					: undefined,
			// permanentCertificateCode: inputRegisterState.permanentCertificateCode,
			/** The permanent certification uploaded file id. */
			permanentCertificateDocument:
				inputRegisterState.typePermanentCertificate !== 'code' && inputRegisterState.proofInputFile
					? (inputRegisterState.proofInputFile as RegisterFileUploadType).id
					: undefined,
			// permanentCertificateDocument: getRequestValue(
			// 	payloadData?.proofInputFile?.id,
			// 	inputRegisterState.proofInputFile?.id
			// ),
			/** The list of users associated with this entity. */
			users: usersData,
			/** The iban of the entity. */
			iban: inputRegisterState.ibanNumber,
			/** The uploaded iban proof file id. */
			ibanDocument: inputRegisterState.ibanInputFile
				? (inputRegisterState.ibanInputFile as RegisterFileUploadType).id
				: undefined,
			/** The uploaded contract file id. */
			contractCode: inputRegisterState.contractInputFile
				? (inputRegisterState.contractInputFile as RegisterFileUploadType).id
				: undefined,
		};

		/* API call */
		const apiContext = ApiClientManager.call<ApiClientTypes.EnrollmentApi>(ApiClientNames.EnrollmentApi);
		const res: EnrollmentTypes.Request = yield call([apiContext, apiContext.sendForApprovalUsingPOST], request);

		LoggerHelper.log('PUBLIC REGISTER > SAGA > handleSendForApprovalFetch > res ', res);

		if (res) {
			// Save all like update data success action
			yield put(fetchUpdateRegisterDataSuccess(res));

			LoggerHelper.log('PUBLIC REGISTER > SAGA > handleSendForApprovalFetch > action.meta ', action.meta);
			if (action.meta && action.meta.successHandler) {
				action.meta.successHandler(true);
			}
		}
	} catch (err) {
		action.meta = { ...action.meta, showModalError: true };
		yield* handleApiError('pt', err, saveError, action.meta);
	} finally {
		yield put(hideLoading());
	}
}

export function* handleUploadFileExecutionFetch(action: ActionServicePayload<FileUploadType>): SagaIterator<void> {
	yield put(clearError());
	yield put(showLoading());

	LoggerHelper.log('PUBLIC REGISTER > SAGA > handleUploadFileExecutionFetch > ');
	try {
		//debugger;
		const payloadData = action.payload as FileUploadType;

		const externalId = yield select(getExternalId); // 'd840fa4c-192a-40fa-b912-9be54d4eb2f6';

		//debugger;
		// Params
		const request: EnrollmentTypes.EnrollmentDocument = {
			enrollmentId: externalId,
			fileName: payloadData.name,
			extention: payloadData.type as string,
			documentType: payloadData.inputType
				? EnrollmentTypes.EnrollmentDocumentDocumentType[payloadData.inputType]
				: EnrollmentTypes.EnrollmentDocumentDocumentType.CC,
			/** Base64 encoded */
			data: payloadData.base64File as string,
		};

		// API call
		const apiContext = ApiClientManager.call<ApiClientTypes.EnrollmentApi>(ApiClientNames.EnrollmentApi);
		const res: EnrollmentTypes.AddEnrollmentDocumentOutput = yield call(
			[apiContext, apiContext.addEnrollmentDocumentUsingPOST],
			request,
			externalId
		);

		LoggerHelper.log('PUBLIC REGISTER > SAGA > handleUploadFileExecutionFetch > res', res);
		if (res) {
			LoggerHelper.log('PUBLIC REGISTER > SAGA > handleUploadFileExecutionFetch > action.meta ', action.meta);
			if (action.meta && action.meta.successHandler) {
				action.meta.successHandler(res.fileId as string);
			}

			//debugger;
			yield put(
				//TODO: Mocked return object from request; only for test
				fetchUploadFileExecutionSuccess({
					id: res.fileId as string,
					fileName: payloadData.name,
					inputType: payloadData.inputType
						? EnrollmentTypes.EnrollmentDocumentDocumentType[payloadData.inputType]
						: EnrollmentTypes.EnrollmentDocumentDocumentType.CC,
				})
			);
		}
	} catch (err) {
		action.meta = { ...action.meta, showModalError: true };
		yield* handleApiError('pt', err, saveError, action.meta);
	} finally {
		yield put(hideLoading());
	}
}

export function* handleDownloadContractFileFetch(action: ActionServiceEmpty): SagaIterator<void> {
	yield put(clearError());
	yield put(showLoading());

	LoggerHelper.log('PUBLIC REGISTER > SAGA > handleDownloadContractFileFetch > ');
	try {
		// Params
		const externalId = yield select(getExternalId); // 'd840fa4c-192a-40fa-b912-9be54d4eb2f6';

		// API call
		const apiContext = ApiClientManager.call<ApiClientTypes.EnrollmentApi>(ApiClientNames.EnrollmentApi);
		const res: EnrollmentTypes.File = yield call([apiContext, apiContext.generateDocumentUsingGET], externalId);

		LoggerHelper.log('PUBLIC REGISTER > SAGA > handleDownloadContractFileFetch > res', res);
		if (res) {
			LoggerHelper.log('PUBLIC REGISTER > SAGA > handleDownloadContractFileFetch > action.meta ', action.meta);
			if (action.meta && action.meta.successHandler) {
				action.meta.successHandler(res);
			}
		}
	} catch (err) {
		action.meta = { ...action.meta, showModalError: true };
		yield* handleApiError('pt', err, saveError, action.meta);
	} finally {
		yield put(hideLoading());
	}
}

export function* handleDownloadRegisterDocumentByIdFetch(action: ActionServicePayload<string>): SagaIterator {
	yield put(clearError());
	yield put(showLoading());

	try {
		/* Params */
		const externalId = yield select(getExternalId);
		const fileId = action.payload;

		/* API call */
		const apiContext = ApiClientManager.call<ApiClientTypes.EnrollmentApi>(ApiClientNames.EnrollmentApi);
		const res: EnrollmentTypes.File = yield call(
			[apiContext, apiContext.getEnrollmentDocumentUsingGET],
			externalId,
			fileId
		);

		LoggerHelper.log('PUBLIC REGISTER > SAGA > downloadRegisterDocumentByIdFetch > res > ', res);

		// if (res) {
		// 	yield put(downloadAttachmentByIdSuccess(res));
		// }
		if (res) {
			LoggerHelper.log('PUBLIC REGISTER > SAGA > downloadRegisterDocumentByIdFetch > action.meta ', action.meta);
			if (action.meta && action.meta.successHandler) {
				action.meta.successHandler(res);
			}
		}
	} catch (err) {
		yield* handleApiError('pt', err, saveError, action.meta);
	} finally {
		yield put(hideLoading());
	}
}

function* watchFetchRequest(): SagaIterator {
	yield takeEvery(RegisterPharmacyActionTypes.FETCH_PUBLIC_REGISTER_INIT_REQUEST, handlePublicRegisterInitFetch);
	yield takeEvery(RegisterPharmacyActionTypes.FETCH_UPDATE_REGISTER_DATA_REQUEST, handleUpdateRegisterDataFetch);
	yield takeEvery(RegisterPharmacyActionTypes.FETCH_UPLOAD_FILE_EXECUTION_REQUEST, handleUploadFileExecutionFetch);
	yield takeEvery(RegisterPharmacyActionTypes.FETCH_SEND_FOR_APPROVAL_REQUEST, handleSendForApprovalFetch);
	yield takeLatest(RegisterPharmacyActionTypes.FETCH_DOWNLOAD_CONTRACT_FILE_REQUEST, handleDownloadContractFileFetch);
	yield takeLatest(
		RegisterPharmacyActionTypes.FETCH_DOWNLOAD_DOCUMENT_REQUEST,
		handleDownloadRegisterDocumentByIdFetch
	);
	yield takeLatest(RegisterPharmacyActionTypes.RESUME_REGISTER_REQUEST, handlePublicRegisterResumeFetch);
	yield takeLatest(RegisterPharmacyActionTypes.SAVE_REGISTER_ON_CANCEL, handleSaveRegisterOnCancel);
}

function* registerPharmacySaga(): object {
	yield all([watchFetchRequest()]);
}

export default registerPharmacySaga;
